import { useEffect } from "react";
import { CleanLayout } from "../../components/Layout/layout";
import { Seo } from "../../components/utils/Seo";
import { useSiteMetadata } from "../../hooks/useSiteMetaData";
import Gtm from "../../components/utils/Gtm";
import Section from "../../components/molecules/Section";
import NavbarShop from "../../components/molecules/NavbarShop";
import FooterShop from "../../components/molecules/FooterShop";
import { eCommerce } from "../../data/e-commerce/index";
import components from "./components";
import FlexSection from "../../components/organisms/FlexSection";
import FooterCopyright from "../../components/molecules/FooterCopyright";
import { CartProvider } from "react-use-cart";
import getDomainInfo from "../../api/getDomainInfo";
import { amplitudeTrackEvent } from "../../components/utils/Amplitude/index";
import "./styles.scss";
import CookiePolicy from "../../components/atoms/CookiePolicy/cookiePolicy";

const Shop = () => {
  const data = eCommerce;
  const { data: domainData } = getDomainInfo();

  useEffect(() => {
    amplitudeTrackEvent("view_landing_home", {
      content: "landing-fake",
    });
  }, []);

  return (
    <CleanLayout theme="e-commerce">
      <CookiePolicy />
      <CartProvider id="shop">
        <NavbarShop
          items={data.navLinks}
          logo={data.metas.logoPath}
        />
        {data.sections.map((section) => {
          let RenderComponent = section.component && components[section.component.name];
          return (
            <Section
              key={section.id}
              id={section.id}
              hero={section.hero}
              background={section.backgroundImages}
              overlay={section.overlay}
              imageOverlay={section.imageOverlay}
              imageGradient={section.imageGradient}
              titleTag={section.titleTag}
              title={section.title}
              subtitle={section.subtitle}
              twoCols={section.twoCols}
              centered={section.centered}
              content={section.content}
              component={section.component && <RenderComponent {...section.component.props} />}
            />
          );
        })}
        <section
          id="benefit"
          className="section section--centered section--benefit">
          <FlexSection
            type="center"
            mobileColumns={true}
            columns={data.benefits}
          />
        </section>
        <FooterShop
          navItems={data.footer.nav}
          logoPath={data.footer.logoPath}
        />
        <FooterCopyright
          domainData={domainData}
          className="footer__copyright"
        />
      </CartProvider>
    </CleanLayout>
  );
};

export default Shop;

export const Head = () => {
  const { title } = useSiteMetadata();

  return (
    <Seo title={title}>
      <Gtm />
    </Seo>
  );
};
